var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-col',{staticClass:"mx-auto",attrs:{"md":"8"}},[_c('div',{attrs:{"id":"chartsec"}},[_c('PieChart',{attrs:{"pie-data":_vm.status}}),_c('BarChart',{attrs:{"bar-data":_vm.invoicePerApprover}}),_c('PieChart',{attrs:{"pie-data":_vm.payedCaused}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }